import React, { useState } from "react";
import axios from "../../api/axios";
import ReportFilterBar from "../../components/reports/ReportFilterBar";
import ReportTable from "../../components/reports/ReportTable";

export default function ApprovalLogReport() {
  const [rows, setRows] = useState([]);

  const fetchData = async () => {
    try {
      const res = await axios.get("/api/reports/approval-log");

      const data = res.data.rows || res.data.data || res.data || [];
      setRows(data);
    } catch (err) {
      console.error(err);
      setRows([]);
    }
  };

  const columns = [
    { field: "timesheet_id", header: "Timesheet ID" },
    { field: "approved_by", header: "Approved By" },
    { field: "status", header: "Status" },
    { field: "approved_at", header: "Approved At" }
  ];

  return (
    <>
      <h2>Approval Log</h2>

      <ReportFilterBar
        filters={[]}
        values={{}}
        onChange={() => {}}
        onFetch={fetchData}
      />

      <ReportTable columns={columns} rows={rows} />
    </>
  );
}